import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  students: [],
  studentDetails: null,
  subjectsListLoading: false,
  subjectsListSuccess: null,
  subjectsListError: '',
  activeSubjectsSuccess: null,
  activeSubjectsError: '',
}

export const SubjectsSlice = createSlice({
  name: 'subjects',
  initialState,
  reducers: {
    getAllStudents: (state, action) => {
      state.students = action.payload;
    },
    setStudentDetails: (state, action) => {
      state.studentDetails = action.payload
    },
    resetStudentDetails: (state) => {
      state.studentDetails = null
    },
    setSubjectsListLoading: (state, action) => {
      state.subjectsListLoading = true;
      state.subjectsListSuccess = null;
      state.subjectsListError = '';
    },
    setSubjectsListSuccess: (state, action) => {
      state.subjectsListLoading = false;
      state.subjectsListSuccess = action.payload;
      state.subjectsListError = '';
    },
    setSubjectsListError: (state, action) => {
      state.subjectsListLoading = false;
      state.subjectsListSuccess = null;
      state.subjectsListError = action.payload;
    },
    setActiveSubjectsSuccess: (state, action) => {
      state.activeSubjectsSuccess = action.payload?.map((item) => ({ ...item, label: item.name, value: item.id }))
      state.activeSubjectsError = '';
  },
  setActiveSubjectsError: (state, action) => {
      state.activeSubjectsSuccess = null;
      state.activeSubjectsError = action.payload;
  },
  },
})

export const { getAllStudents, setStudentDetails, resetStudentDetails, setSubjectsListLoading, setSubjectsListSuccess, setSubjectsListError,setActiveSubjectsSuccess, setActiveSubjectsError, } = SubjectsSlice.actions

export default SubjectsSlice.reducer;